import { Component, ElementRef, Input, NgZone, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import * as hljs from 'highlight.js/lib/core';


@Component({
  selector: 'app-token',
  templateUrl: './token.component.html',
  styleUrls: ['./token.component.css']
})
export class TokenComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;

  constructor() {
  }




  ngOnInit(): void {
  }

  jsonData = `

  curl --location 'https://api.optimusdrive.ai/v1/customer/auth' \
  --header 'Content-Type: application/json' \
  --header 'Accept: application/json' \
  --data-raw '{
  "username": "youremailid@yopmail.com",
  "password": "Password@123"
  }'
  
  `

  tokenData = `{
    "data": {
    "AuthenticationResult": {
    "AccessToken": "xyz"
    "ExpiresIn": 3600,
    "IdToken": "abcd1234"
    "NewDeviceMetadata": {
    "DeviceGroupKey": "-oeHL8RDA",
    "DeviceKey": "us-east-1_7e22ddef-fe9d-4195-816b-157a1f611d9a"
    },
    "RefreshToken": "xyz"
    "TokenType": "Bearer"
    },
    "ChallengeName": null,
    "ChallengeParameters": {},
    "Session": null
    },
    "message": "Authenticated successfully"
   }`





  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
       this.copyButton = false;
       this.copiedButton = true;
  // After a few seconds, reset the button states
      setTimeout(() => {
        this.copyButton = true;
        this.copiedButton = false;
      }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.jsonData);
  }



}








